export const MAX_FILE_SIZE = 5242880;
export const BYTES_IN_MB = 1000000;
